import { fetchAuthSession } from "@aws-amplify/auth";
import Axios, { AxiosError, AxiosRequestConfig } from "axios";

import i18n from "../translation/i18n";

export const AXIOS_INSTANCE = Axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/o1-typescript-service`,
});

// Add a response interceptor to redirect on 401 Unauthorized errors
AXIOS_INSTANCE.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response && error.response.status === 401) {
      const params = new URLSearchParams(window.location.search);

      if (params.has("code")) {
        return Promise.reject(error);
      }

      if ((error.response?.data as { error: string })?.error === "TooManyRequestsException") {
        return Promise.reject(error);
      }

      window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);

export const customInstance = async <T>(
  config: AxiosRequestConfig,
): Promise<T> => {
  // Get the current session from Amplify to extract the token
  const session = await fetchAuthSession();
  const token = session.tokens?.idToken?.toString();

  // Add the Authorization header with the token to the request config
  config.headers = {
    ...config.headers,
    Authorization: `${token}`,
    "Accept-Language": i18n.language,
    "X-Partner-Id": process.env.REACT_APP_PARTNER_ID,
  };

  const source = Axios.CancelToken.source();
  return AXIOS_INSTANCE({ ...config, cancelToken: source.token }).then(
    ({ data }) => data,
  );
};

export default customInstance;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export interface ErrorType<Error>
  extends AxiosError<{
    message: string;
    error: string;
  }> {}
